import { useState } from "react";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";
import { X, Flag } from "lucide-react";

const TYPES = [
  { v: "incorrect_answer", l: "Incorrect answer" },
  { v: "bad_clue", l: "Bad or confusing clue" },
  { v: "outdated", l: "Outdated content" },
  { v: "spelling", l: "Spelling issue" },
  { v: "duplicate", l: "Duplicate" },
  { v: "inappropriate", l: "Inappropriate content" },
  { v: "other", l: "Other" },
];

export function ReportModal({ puzzleId, clueRef, onClose }) {
  const [type, setType] = useState("incorrect_answer");
  const [message, setMessage] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    setBusy(true);
    try {
      await api.post("/community/report", { puzzle_id: puzzleId, clue_ref: clueRef, type, message });
      toast.success("Report sent. Thanks for helping us improve!");
      onClose();
    } catch (e) {
      toast.error(apiError(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm" data-testid="report-modal">
      <div className="w-full max-w-md bg-card border-2 border-primary p-6 fade-up">
        <div className="flex items-center justify-between mb-5">
          <h3 className="font-display text-2xl flex items-center gap-2"><Flag size={20} className="text-primary" /> Report a Problem</h3>
          <button onClick={onClose} data-testid="report-close" className="text-muted-foreground hover:text-foreground"><X size={20} /></button>
        </div>
        <label className="font-mono-caps text-[10px] text-muted-foreground">Problem type</label>
        <select value={type} onChange={(e) => setType(e.target.value)} data-testid="report-type-select"
          className="w-full mt-1 mb-4 bg-background border border-border px-3 py-2 outline-none focus:ring-2 focus:ring-primary text-sm">
          {TYPES.map((t) => <option key={t.v} value={t.v}>{t.l}</option>)}
        </select>
        <label className="font-mono-caps text-[10px] text-muted-foreground">Details (optional)</label>
        <textarea value={message} onChange={(e) => setMessage(e.target.value)} rows={3} data-testid="report-message"
          placeholder="What's wrong?" className="w-full mt-1 mb-5 bg-background border border-border px-3 py-2 outline-none focus:ring-2 focus:ring-primary text-sm resize-none" />
        <button onClick={submit} disabled={busy} data-testid="report-submit"
          className="w-full bg-primary text-primary-foreground font-mono-caps text-xs py-3 hover-lift border border-primary disabled:opacity-50">
          {busy ? "Sending..." : "Submit Report"}
        </button>
      </div>
    </div>
  );
}
